import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { AzureISVFilterConfig } from './filters/AzureISVFilterConfig';

export const CompeteTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: ['@Azure Compete'],
  searchNodeName: [UATConstants.PlaceholdersAndTitles.CompeteAccordian],
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: true,
    SensativeInfoErrorCount: true,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: [],
      AreaPath: UATConstants.CompeteAreaPath,
      Title: UATConstants.TenantTitles.Compete,
      ADOTitle: UATConstants.TenantADOText.Compete,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateCompeteRequest,
          Key: UATConstants.CreateActionMenuKey.CreateCompeteRequest,
          NodeName: '',
        },
      ],
      Download: true,
      RelatedItem: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
    },
    ManageAction: {
      NewExperience: false,
      MandateFormPickers: [],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: true,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isFieldConfigurationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: false,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '0d7155cb-83ee-45f9-8168-8ab7355f50d9',
      systemViewsFolderId: 'd915e8b3-a561-49ba-bc24-991acb291159',
      sharedViewsFolderId: '789df76a-fb19-4409-b8b2-0a6954d90e0a',
    },
  },
};